<!--站点自定义模板-->
<template>
    <div id="userList">
        <div class="searchContent">
            <div class="p_select" style="float: right;">
                <a  class="add_btn" @click="addItem"><i class="el-icon-plus"></i>新增</a>
            </div>
        </div>


        <div class="list_content">
            <el-table :data="listData" :height="winHeight">
                <el-table-column prop="reasonId" label="ID"></el-table-column>
                <el-table-column prop="label" label="失销原因"></el-table-column>

                <el-table-column label="状态" align="left">
                    <template slot-scope="scope">
                        <el-switch
                                v-model='scope.row.isUsing'
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                active-text="启用"
                                inactive-text="禁用"
                                active-value='1'
                                inactive-value='0'
                                @change="changeIsNeed(scope.row.isUsing,scope.row)"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="140">
                    <template slot-scope="scope">
                        <el-button @click="editItem(scope.row)" class="update_btn" size="small">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-drawer
                title="新增失销原因"
                :visible.sync="showAddData"
                direction="rtl"
                :wrapperClosable=true
                @close="noUpdateData">
            <el-form ref="form" label-width="100px" style="height: 300px">
                <el-form-item label="失销原因:" required>
                    <el-input v-model="label" placeholder="请输入失销原因"></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitAdd">确认新增</a>
                <a class="cancel_btn" @click="noUpdateData">取消</a>
            </div>
        </el-drawer>

        <el-drawer
                title="修改失销原因"
                :visible.sync="showEditData"
                direction="rtl"
                :wrapperClosable=true
                @close="noUpdateData">
            <el-form ref="form" label-width="100px" style="height: 300px">
                <el-form-item label="失销原因:" required>
                    <el-input v-model="label" placeholder="请输入失销原因"></el-input>
                </el-form-item>
            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitEdit">确认修改</a>
                <a class="cancel_btn" @click="noUpdateData">取消</a>
            </div>
        </el-drawer>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  export default {
    data() {
      return {
        listData: [],
        total: 0,
        pageNo: 1,
        pageSize: 10,
        orgArr: [],
        orgId: 0,
        positionArr: [],

        label:'',
        reasonId:'',
        isUsing:'',
        positionId: 0,
        showAddData: false,
        resultConfigId:0,
        isHandle1 : false,
        isHandle2 : false,

        showEditData: false,
        showDeleteData: false,

        winHeight:'200'
      };
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.getListData()
    },
    methods: {
      getListData(){
        const params = {
          orgId: this.orgId
        }
        net.request('admin/manage/reason_config/queryOrgReasons', 'post', params).then(res => {
          if(res.code === 0){
            res.data.forEach(item => {
              item.isUsing = item.isUsing+''
            })
            this.listData = res.data
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
            this.winHeight = windiwHight - 172;
          }else {
            net.message(this, res.msg, "warning");
          }
        })
      },
      addItem() {
        this.showAddData = true
        this.label = ''
      },
      submitAdd() {
        if (this.label == '' || this.label == null) {
          net.message(this, '必填项不能为空', "error");
          return
        }
        if(this.label.length > 12){
          net.message(this, '请控制在12个字以内', "error");
          return
        }
        const params = {
          orgId: this.orgId,
          label: this.label,
          isUsing:1
        }
        net.request("admin/manage/reason_config/addReason", "post", null, params).then(res => {
          if (res.code === 0) {
            this.showAddData = false
            net.message(this, res.msg, "success");
            this.getListData()
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      editItem(row) {
        this.label = row.label
        this.reasonId = row.reasonId
        this.isUsing = row.isUsing
        this.showEditData = true
      },
      changeIsNeed(isUsing,row){
        const params = {
          reasonId: row.reasonId,
          label: row.label,
          isUsing: isUsing * 1,
        }
        net.request('admin/manage/reason_config/editReason','post',null, params).then(res => {
          if (res.code === 0) {
            this.showEditData = false
            net.message(this, res.msg, "success");
            this.getListData()
          } else {
            net.message(this, res.msg, "warning");
          }
        })
      },
      submitEdit() {
        if (this.label == '' || this.label == null) {
          net.message(this, '必填项不能为空', "error");
          return
        }
        if(this.label.length > 12){
          net.message(this, '请控制在12个字以内', "error");
          return
        }
        const params = {
          label: this.label,
          reasonId: this.reasonId,
          isUsing: this.isUsing,
        }
        net.request("admin/manage/reason_config/editReason", "post", null, params).then(res => {
          if (res.code === 0) {
            this.showEditData = false
            net.message(this, res.msg, "success");
            this.getListData()
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      noUpdateData() {
        this.showAddData = false
        this.showEditData = false
        this.getListData()
      },


    },
  };
</script>

<style lang='less' scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
    #userList {
        margin-left: 24px;
        .searchContent {
            height: 60px;
            background: #fff;
            margin: 24px 0 0px 0;
            padding-left: 12px;
            padding-top: 12px;
            .p_select {
                display: flex;
                padding: 0 12px 12px 0;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                width: 76px;
                height: 38px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

        }
        .list_content {
            background: #fff;
            padding-left: 12px;
            padding-right: 12px;
            overflow: hidden;
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
            background: #009688;
        }
        .update_btn {
            width: 54px;
            height: 28px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            font-size: 12px;
            color: #364556;
            text-align: center;
        }
        .name_box {
            .worker_name {
                padding: 4px 6px;
                float: left;
                margin: 4px;
                border-radius: 10px;

            }
            .is_use {
                background-color: #f0f9eb;
                border-color: #e1f3d8;
                color: #67c23a;
            }
            .no_use {
                background-color: #ffecec;
                color: #ff4040;
                border: 1px solid #ffecec;
            }
        }
    }


</style>

